import { baseApi } from '../baseApi';
import type { ListParams } from '../api';

export interface Student {
  id: string;
  name: string;
  email: string;
  mobile: string;
  yearId: string;
  enrollmentDate: string;
  createdAt: string;
  status: "active" | "inactive";
  supportKey: boolean;
  collegeName?: string;
  state?: string;
  referralCode?: string;
  courseName?: string;
}

export interface ListResponse<T> {
  data: T[];
  total: number;
  page: number;
  limit: number;
}

export const studentApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    getStudents: b.query<ListResponse<Student>, ListParams>({
      query: (params = {}) => ({ url: "/api/students", params }),
      providesTags: ["User"] as any, // using User tag or add Student to baseApi tagTypes
    }),
    addStudent: b.mutation<Student, Partial<Student>>({
      query: (body) => ({ url: "/api/students", method: "POST", body }),
      invalidatesTags: ["User", "Dashboard"] as any,
    }),
    updateStudent: b.mutation<Student, { id: string; body: Partial<Student> }>({
      query: ({ id, body }) => ({ url: `/api/students/${id}`, method: "PATCH", body }),
      invalidatesTags: ["User", "Dashboard"] as any,
    }),
    deleteStudent: b.mutation<{ success: boolean; id: string }, string>({
      query: (id) => ({ url: `/api/students/${id}`, method: "DELETE" }),
      invalidatesTags: ["User", "Dashboard"] as any,
    }),
  }),
});

export const {
  useGetStudentsQuery,
  useAddStudentMutation,
  useUpdateStudentMutation,
  useDeleteStudentMutation,
} = studentApi;
